import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ToasterService {
    defaultToasterValue: ToasterOption = {};
    constructor(public toastr: ToastrService) { }

    setToasterValue() {
        this.defaultToasterValue = {
            timeOut: 3000,
            enableHtml: false,
            closeButton: true,
            tapToDismiss: true,
            progressBar: false,
        };
    }

    showToaster(title?: string, message?: string, toasterType?: ToasterType, toasterOption?: ToasterOption) {
        this.toastr.toastrConfig.maxOpened = 5
        this.toastr.toastrConfig.preventDuplicates = true
        this.setToasterValue()
        let updatedToasterOptions: ToasterOption = {};
        // tslint:disable-next-line:triple-equals
        if (toasterOption != undefined) {
            updatedToasterOptions = {
                timeOut: toasterOption.timeOut === undefined ? this.defaultToasterValue.timeOut : toasterOption.timeOut,
                enableHtml: toasterOption.enableHtml === undefined ? this.defaultToasterValue.enableHtml : toasterOption.enableHtml,
                closeButton: toasterOption.closeButton === undefined ? this.defaultToasterValue.closeButton : toasterOption.closeButton,
                progressBar: toasterOption.progressBar === undefined ? this.defaultToasterValue.progressBar : toasterOption.progressBar,
                tapToDismiss: toasterOption.tapToDismiss === undefined ? this.defaultToasterValue.tapToDismiss : toasterOption.tapToDismiss,
            }
        } else {
            updatedToasterOptions = this.defaultToasterValue;
        }
        switch (toasterType) {
            case ToasterType.Success:
                this.toastr.success(message, title, updatedToasterOptions);
                break;
            case ToasterType.Error:
                this.toastr.error(message, title, updatedToasterOptions);
                break;
            case ToasterType.Info:
                this.toastr.info(message, title, updatedToasterOptions);
                break;
            case ToasterType.Warning:
                this.toastr.warning(message, title, updatedToasterOptions);
                break;
            default:
                this.toastr.info(message, title, updatedToasterOptions);
        }
    }

    createToastr(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.success(moduleName + ' Created Successfully.', '', this.defaultToasterValue)
    }
    updateToastr(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.success(moduleName + ' Updated Successfully.', '', this.defaultToasterValue)
    }
    deleteToastr(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.success(moduleName + ' Deleted Successfully.', '', this.defaultToasterValue)
    }
    freezeToastr(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.success(moduleName + ' Freeze Successfully.', '', this.defaultToasterValue)
    }
    unfreezeToastr(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.success(moduleName + ' Unfreeze Successfully.', '', this.defaultToasterValue)
    }
    requiredValidation(moduleName) {
        this.setToasterValue()
        this.toastr.toastrConfig.maxOpened = 1
        this.toastr.toastrConfig.preventDuplicates = true
        this.toastr.error('Please enter required fields', '', this.defaultToasterValue)
    }
}
export enum ToasterType {
    Success,
    Error,
    Info,
    Warning,
    Custom,
    WithProgressBar
}
export class ToasterOption {
    enableHtml?: boolean;
    progressBar?: boolean;
    timeOut?: number;
    tapToDismiss?: boolean;
    closeButton?: boolean;
    titleClass?: string;
    messageClass?: string;
}
